<template>
  <div>
    <div class="row">
      <div class="col-3">
        <div class="profile-card p-2">
          <div class="image-card p-1">
            <img src="../../assets/image/man.png" />
          </div>
          <p class="heading my-0">Hi Saravanan &#128075;</p>
          <p class="fade-text my-0 text-center">Admin</p>
        </div>
        <!-- <div class="profile-card my-4">
          <div class="d-flex">
                    <div class="flex-end float-end mx-2">
                        <font-awesome-icon icon="fa-solid fa-user-plus" />
                    </div>
                </div> 
          <Jumbotron>
            <div class="d-flex mt-2">
              <img
                src="../../assets/svg/flag.svg"
                alt=""
                srcset=""
                width="30"
                class="mb-3"
              />
              <h4 class="heading ms-3">Manage Employees</h4>
              <Button
                label="view"
                class="qb-btn qb-btn-primary-md ms-auto"
                @onClick="navigate()"
              />
            </div>
            <p class="normal-text mb-2">
              Create and manage Employee. Employee can be created and assigned
              with tasks.
            </p>
          </Jumbotron>
        </div> -->
        <div class="profile-card p-3 my-4">
          <div class="d-flex">
            <div class="user-icon">
              <font-awesome-icon icon="fa-solid fa-users" class="m-3" />
            </div>
            <div class="flex">
              <p class="my-0 mx-2 count">{{ userList.length }}</p>
              <p class="my-0 mx-2 fade-text">Total Users</p>
            </div>
            <!-- <div class="flex-end float-end mx-2"><font-awesome-icon icon="fa-solid fa-user-plus" /></div> -->
          </div>
        </div>
      </div>

      <div class="col-5">
        <div class="profile-card">
          <div class="d-flex p-2">
            <DropDown
              class="flex-fill m-1"
              :items="userListOption"
              :selectLabel="employee.name || 'Select Employee'"
              @callBackValue="handleUser"
              v-model="employeeSearchTerm"
              placeholder="Search for user"
            />
            <DropDown
              class="flex-fill m-1"
              :items="worksheets"
              :selectLabel="employee.worksheet || 'Select Worksheet'"
              @callBackValue="handleWorksheet"
              v-model="moduleSearchTerm"
              placeholder="Search for worksheet"
            />
          </div>
          <div class="m-2">
            <ApexChart
              type="line"
              height="250"
              :options="chartOptions"
              :series="series"
            ></ApexChart>
          </div>

          <div class="m-2 task-data border">
            <p class="sub-heading p-2 m-0">Submission</p>
            <hr class="my-0">
            <div class="qb-container">
            <div v-for="(day, index) in worksheetdata" :key="index" class="m-2">
              <div
                class="mx-2 p-2 qb-card d-flex justify-content-between"
                data-bs-toggle="collapse"
                :data-bs-target="'#collapseExample' + index"
              >
                <div>
                  <p class="normal-text my-0">
                    {{ day.day.replaceAll("_", " ") }}
                  </p>
                </div>
                <Badge
                  :label="day.status.replaceAll('_',' ')"
                  :class="[
                      day.status === 'COMPLETED'
                        ? 'badge-neon badge-neon-success-outline'
                        : '',
                      day.status === 'IN_PROGRESS'
                        ? 'badge-neon badge-neon-warning-outline'
                        : '',
                      day.status === 'NOT_YET_STARTED'
                        ? 'badge-neon badge-neon-error-outline'
                        : '',
                    ]"
                />
              </div>
              <!-- <div class="collapse " :id="'collapseExample' + index">
                  <div>
                  <div @click="toggleEvaluationModal(task)" v-for="(task,index) in day.taskList" :key="index" >
                <Card >
                   {{task.task.title}}
                </Card>
                  </div>
                  </div>
                </div> -->

              <div class="collapse" :id="'collapseExample' + index">
                <div class="p-0 card-box m-2">
                  <div
                    @click="toggleEvaluationModal(task)"
                    v-for="(task, index) in day.taskList"
                    :key="index"
                  >
                    <Card class="module-card p-1 m-2">
                      <div class="p-3">
                        <p class="task-title">{{ task.task.title }}</p>
                        <div class="d-flex justify-content-between">
                          <Badge
                            :label="'Type: ' + task.task.submissionType"
                            class="badge-rounded badge-rounded-grey-outline"
                          />
                          <Badge
                            :label="task.status ? 'Completed' : 'Not Completed'"
                            :class="
                              task.status
                                ? 'badge-neon badge-neon-success-outline'
                                : 'badge-neon badge-neon-error-outline'
                            "
                          />
                          <!-- <p class="reporter-label">Submission Type :</p>
                   <p class="reporter-title">{{task.task.submissionType}}</p> -->
                        </div>
                      </div>
                    </Card>
                  </div>
                </div>
              </div>
            </div>
            </div>
          </div>
        </div>
        <Modal
          @close="toggleEvaluationModal"
          :modalActive="showEvaluationModal"
          v-if="selectedTask"
        >
          <div class="d-flex">
            <h4 class="modal-heading flex-fill">
              {{ selectedTask.task.title }}
            </h4>
            <Badge
              :label="selectedTask.status ? 'COMPLETED' : 'INCOMPLETE'"
              :class="
                selectedTask.status
                  ? 'badge-neon badge-neon-success-outline'
                  : 'badge-neon badge-neon-error-outline'
              "
            />
          </div>
          <hr class="mb-2 m-0 p-0" />
          <div>
            <!-- {{selectedTask.completedDate}} -->
            <Card class="p-2 mb-2 m-1"
              ><div
                class="description"
                v-html="selectedTask.task.description"
              ></div>
              <!-- <Badge :label="task.status ? 'Completed' : 'Not submitted'" :class="['badge-rounded float-end',{'badge-neon-success-outline':task.status},{'badge-neon-error-outline':!task.status}]"/> -->
            </Card>
            <div class="p-2 m-1 mb-2 submission">
              <p class="sub-heading my-0" v-if="selectedTask.task.submissionType=='LINK'">Link :</p>
              <a target="_blank" href="https://www.google.com"
                >{{ selectedTask.link }}
              </a>
              <p class="sub-heading my-0 mt-1">Comments :</p>
              <p class="mb-0">{{ selectedTask.comment }}</p>
              <!-- <p><Badge :label="'Start Date : '+task.startDate" 
              class="badge-rounded badge-rounded-grey-outline float-start"></Badge>
              <Badge :label="'Completed Date : '+task.completedDate" 
              class="badge-rounded badge-rounded-grey-outline float-end"></Badge></p> -->
            </div>
          </div>
        </Modal>
      </div>

      <Card class="col-4 history-card">
        <div>
          <div class="border-bottom">
            <p class="sub-heading p-1 m-1">Recently Completed</p>
          </div>
          <div class="history-body">
            <div
              class="history p-2 m-2 d-flex"
              v-for="(history, index) in historyList"
              :key="index"
            >
              <div class="flex-grow-1">
                <p class="my-0 normal-text">
                  {{ history.userName }}
                  <Badge
                    :label="formatDate(history.completedDate)"
                    class="badge-neon badge-neon-warning-outline"
                  />
                </p>
                <p class="my-0 fade-text">
                  {{ history.day.replaceAll("_", " ") }} |
                  {{ history.taskName }}
                </p>
              </div>
              <div class="check float-end">
                <img src="../../assets/image/check.png" class="my-2" />
              </div>
            </div>
          </div>
        </div>
      </Card>
    </div>

    <!-- <div class="profile-card mt-4">
      <p class="my-0 p-3 sub-heading">Employee List</p>
      <hr class="my-0" />
      <div class="m-3">
        <table class="table table-striped text-center">
          <thead class="thead-dark">
            <tr>
              <th>Name</th>
              <th>Mail</th>
              <th>Designation</th>
              <th>Experience</th>
            </tr>
          </thead>
          <tbody class="table-body">
            <tr
              class="fade-text-table"
              v-for="(user, index) in userList"
              :key="index"
            >
              <td>{{ user.name }}</td>
              <td>{{ user.email }}</td>
              <td>{{ user.designation.replaceAll("_", " ") }}</td>
              <td>
                <Badge
                  :label="user.experience"
                  class="badge-neon badge-neon-success-outline"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div> -->
  </div>
</template>

<script>
import DropDown from "../../components/DropDownSearchComponent.vue";
import Card from "../../components/CardComponent.vue";
// import Button from "../../components/ButtonComponent.vue";
import Badge from "../../components/BadgeComponent.vue";
// import Jumbotron from "../../components/JumbotronComponent.vue";
import Modal from "../../components/ModalComponent.vue";

import { createNamespacedHelpers } from "vuex";
// import AddTaskComponent from '@/components/AddTaskComponent.vue';
const { mapActions: userMapActions, mapGetters } =
  createNamespacedHelpers("User");
const { mapActions: moduleMapActions } = createNamespacedHelpers("Module");
export default {
  name: "AdminDashboard",
  data() {
    return {
      series: [{}],
      chartOptions: {
        chart: {
          height: 250,
          type: "line",
          zoom: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "smooth",
        },
        title: {
          text: "Employee Progress",
          align: "left",
        },
        grid: {
          row: {
            colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
            opacity: 0.5,
          },
        },
        xaxis: {
          type: "datetime",
        },
      },
      employee: {
        name: "",
        id: "",
        worksheet: "",
        worksheetId: "",
      },
      selectedTask: null,
      showEvaluationModal: false,
      employeeSearchTerm: "",
      moduleSearchTerm: "",
    };
  },
  components: {
    Card,
    DropDown,
    // Button,
    Badge,
    // Jumbotron,
    Modal,
  },
  methods: {
    ...moduleMapActions({
      getAllModule: "GET_ALL_MODULE",
    }),
    ...userMapActions({
      getUserList: "GET_USER_LIST",
      getHistory: "GET_ALL_HISTORY",
      getallworksheet: "GET_ALL_WORKSHEET",
      getgraphdata: "GET_GRAPH_DATA_BY_ID",
      getworksheetdata: "GET_WORKSHEET_BY_USER_ID",
    }),
    handleUser({ label, value }) {
      this.employee.name = label;
      this.employee.id = value;
    },
    handleWorksheet({ label, value }) {
      this.employee.worksheet = label;
      this.employee.worksheetId = value;
    },
    navigate() {
      this.$router.push({ path: "/employee" });
    },
    toggleEvaluationModal(task) {
      console.log("clicked..");
      this.selectedTask = task;
      this.showEvaluationModal = !this.showEvaluationModal;
    },
  },
  computed: {
    ...mapGetters({
      userListOption: "getUserListOption",
      userList: "getUserList",
      historyList: "getHistoryList",
      worksheets: "getWorkSheetOption",
      graphdata: "getGraphData",
      worksheetdata: "getCurrentUserWorkSheetList",
    }),
  },
  watch: {
    "employee.id"(val) {
      this.getallworksheet(val);
      this.employee.worksheet = "";
    },
    "employee.worksheetId"(val) {
      this.getgraphdata(val);
      this.getworksheetdata(val);
    },
    employeeSearchTerm(val) {
      this.getUserList({ name: val });
    },
    moduleSearchTerm(name) {
      this.getAllModule({ name });
    },
    graphdata(val) {
      this.series = [
        {
          data: val,
          name: "Tasks",
        },
      ];
    },
  },
  created() {
    this.getUserList({ name: "" });
    this.getHistory();
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/color.scss";
@import "../../assets/scss/font.scss";
@import "../../assets/scss/field.scss";
.row {
  height: 440px;
}
.fa-users {
  font-size: 20px;
  color: green;
}
.user-icon {
  border-radius: 8px;
  background-color: rgb(211, 240, 211);
  width: fit-content;
}
.profile-card {
  //  border:0.5 px solid $light-100;
  // box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  border-radius: 7px;
  background-color: white;
}
.count {
  font-size: $font-size-xxxl;
  font-weight: $font-weight-bold;
}
.heading {
  font-size: $font-size-xl;
  font-weight: $font-weight-bold;
  text-align: center;
}
.sub-heading {
  font-size: $font-size-xl;
  font-weight: $font-weight-bold;
}
.normal-text {
  font-size: $font-size-md;
  font-weight: $font-weight-normal-1;
}
.image-card {
  height: 100px;
  width: 100px;
  margin: auto;
  img {
    max-height: 100%;
  }
}
.fade-text {
  color: $light-500;
  font-size: $font-size-sm;

  // text-align: center;
}
.fade-text-table {
  color: $light-500;
  font-size: $font-size-md;
  padding: 5px;
  // text-align: center;
}
.fade {
  // color:$light-500;
  font-size: $font-size-sm;
}
.history {
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  border-radius: 9px;
}
.history-card {
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  border-radius: 7px;
  background-color: white;
  height: max-content;
}
.history-body {
  height: 650px;
  max-height: 650px;
  overflow: scroll;
}
.check img {
  height: 20px;
  width: 20px;
}

.description {
  max-height: 300px;
  overflow: scroll;
}
.modal-heading {
  font-size: $font-size-xxl;
  font-weight: 600;
}
.sub-heading {
  font-size: $font-size-md;
  font-weight: 600;
}
.submission {
  border: 1px solid $light-200;
  border-radius: $field-border-radius;
}
.qb-card{
  border: 1px solid $light-200;
  border-radius: $field-border-radius;
  cursor:pointer;
}
.card-box::-webkit-scrollbar {
  background: none;
  height: 5px;
}

.card-box::-webkit-scrollbar-thumb {
  background-color: $border-color;
  border-radius: $field-border-radius;
}

.module-card {
  min-width: 250px;
  // max-width: 250px;
}
.card-box {
  padding: 0px 10px 10px 10px;
  border-radius: $field-border-radius;
  display: flex;
  flex-direction: row;
  overflow-x: auto;
  overflow-y: hidden;
  gap: 10px;
}
.card-box:hover {
  cursor: pointer;
}
.task-title {
  font-weight: 600;
  font-size: 14px;
  margin: 0px;
  margin-bottom: 5px;
}
.reporter-label {
  font-size: $font-size-sm;
  color: $badger-orange;
  font-weight: $font-weight-bold;
  margin: 0px;
}

.reporter-title {
  font-size: $font-size-sm;
  color: $light-500;
  font-weight: $font-weight-bold;
  text-transform: lowercase;
  margin: 0px;
}
.task-data {
  // height: 350px;
  // max-height: 350px;
  // overflow: scroll;
  // // background-color: $light-200;
  border-radius: $field-border-radius;
}
.qb-container{
  height: 300px;
  max-height: 350px;
  overflow: scroll;
  border-radius: $field-border-radius;
}
.qb-container::-webkit-scrollbar {
  background: none;
  width: 5px;
  height: 0px;
}
.qb-container::-webkit-scrollbar-thumb {
  background-color: $border-color;
  border-radius: $field-border-radius;
}
.card {
  cursor: pointer;
}
.card:hover {
  background-color: $light-100;
}
</style>
